//@ts-nocheck
import React, { useEffect, useState } from "react";
import styles from "./EditActionsAndData.module.scss";
import actionElements from "config/actionElements.json";
import useCustomForm from "hooks/useCustomForm";
import EditAction from "./EditAction/EditAction";
import ActionElement from "../../ActionElement/ActionElement";
import InfoBubble from "../../InfoBubble/InfoBubble";
import { Button } from "@factorearth/component-library";

function EditActionsAndData(props) {
	const { actionData, dataProp, actionProp, actionType, color, index, handleSubmit, handleCancel, templateData } = props;
	const { handleChange, values } = useCustomForm({ [dataProp]: actionData, [actionProp]: actionType }, null);

	/**
	 * CAllback for submitting.
	 * @param updatedValues event change data, for an update that needs to happen before state can save it in.
	 */
	function handleSubmitClick(updatedValues) {
		const valuesToUse = updatedValues || values;
		// note this is not the useCustomForm handleSubmit at this point.
		handleSubmit(valuesToUse, index);
	}

	function handleActionChange(e) {
		handleChange(e, handleSubmitClick);
	}

	/**
	 * saves the export data that was selected.
	 * @param {string} data to be saved as the corresponding actionData
	 */
	function handleSubmitActionElement(data) {
		const changeData = {
			target: {
				value: data,
				name: dataProp,
			},
		};

		handleChange(changeData, handleSubmitClick);
	}

	/**
	 * Specific filtering for action elements.
	 * @returns list of strings of the action element keys.
	 */
	function filterActionList() {
		const initialAllowed = actionElements[actionProp];
		let filtered = [];

		for (let i = 0; i < Object.entries(initialAllowed).length; i++) {
			const [actionEleKey, actionEle] = Object.entries(initialAllowed)[i];
			if (actionEle.allowedTypes.includes(templateData.inputType)) {
				filtered.push(actionEleKey);
			}
		}

		return filtered;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.export_action_row}>
				<div className={styles.export_action_dropdown}>
					<EditAction
						handleChange={handleActionChange}
						color={color}
						value={values[actionProp]}
						actionProp={actionProp}
						allowed={filterActionList()}
					/>
				</div>
				<div className={styles.info_bubble_wrapper}>
					<InfoBubble
						description={
							actionElements[actionProp][values[actionProp]]
								? actionElements[actionProp][values[actionProp]].description
								: "You must select the type of export action from the dropdown, then you can customize the data"
						}
					/>
				</div>
			</div>
			{actionElements[actionProp][values[actionProp]] ? (
				<div className={styles.selected_export_action}>
					<ActionElement
						actionElement={actionElements[actionProp][values[actionProp]]}
						color={color}
						handleSubmit={handleSubmitActionElement}
						index={index}
						value={values[dataProp]}
						templateData={templateData}
					/>
				</div>
			) : null}
			<div className={styles.button_container}>
				<Button colorPalette={color} onClick={handleCancel} data-test="close-btn">
					Close
				</Button>
			</div>
		</div>
	);
}

export default EditActionsAndData;
